<template>
  <div v-loading="pageLoading">
    <div>
      <el-form label-width="110px" :model="testPage">
        <el-form-item label="反饋表名稱">
          <el-input
            v-model="testPage.ueviomsName"
            type="textarea"
            :rows="3"
            style="width: 300px"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="反饋列表">
          <template>
            <el-table
              :data="tableData"
              border
              empty-text="暫無記錄"
              max-height="500"
              style="width: 70%"
            >
              <el-table-column
                type="index"
                label="序號"
                width="60px"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="content"
                label="題目"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="optionA"
                label="選項A"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="optionB"
                label="選項B"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="optionC"
                label="選項C"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="optionD"
                label="選項D"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="del(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 20px; display: flex">
              <el-button icon="el-icon-plus" @click="dialogFormVisible = true"
                >新增題目</el-button
              >
              <el-button @click="importTemplate" type="primary"
                >導入模板</el-button
              >
            </div>
          </template>
        </el-form-item>
        <el-form-item label="問答題名稱">
          <template v-for="(item, index) in questionnaireName">
            <el-input
              :key="'input-' + index"
              v-model="questionnaireName[index]"
              type="textarea"
              :rows="3"
              style="width: 300px; margin-right: 5px"
              maxlength="30"
              show-word-limit
            >
            </el-input>
            <el-badge
              value="X"
              :key="'del-' + index"
              class="item"
              @click.native="delQuestionnaire(index)"
            >
            </el-badge>
          </template>
          <div style="margin-top: 20px; display: flex">
            <el-button
              icon="el-icon-plus"
              @click="dialogFormQuestionnaire = true"
              >新增問答</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="$emit('back')">取 消</el-button>
        <el-button type="primary" @click="addAsses">確 定</el-button>
      </div>
      <el-button class="btn" @click="back()">返 回</el-button>
      <!-- 新增題目的彈窗 -->
      <el-dialog
        title="新增題目"
        :visible.sync="dialogFormVisible"
        width="600px"
      >
        <el-form v-model="topic" label-width="80px">
          <el-form-item label="題目">
            <el-input
              type="textarea"
              style="width: 400px"
              v-model="topic.content"
            ></el-input>
          </el-form-item>
          <el-form-item label="A">
            <el-input v-model="topic.optionA"></el-input>
          </el-form-item>
          <el-form-item label="B">
            <el-input v-model="topic.optionB"></el-input>
          </el-form-item>
          <el-form-item label="C">
            <el-input v-model="topic.optionC"></el-input>
          </el-form-item>
          <el-form-item label="D">
            <el-input v-model="topic.optionD"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addTopic">確 定</el-button>
        </div>
      </el-dialog>

      <!-- 新增問答的彈窗 -->
      <el-dialog
        title="新增問答"
        :visible.sync="dialogFormQuestionnaire"
        width="600px"
      >
        <el-input
          v-model="testPage.name"
          type="textarea"
          :rows="3"
          style="width: 300px"
          maxlength="30"
          show-word-limit
        ></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormQuestionnaire = false">取 消</el-button>
          <el-button type="primary" @click="addQuestionnaire">確 定</el-button>
        </div>
      </el-dialog>
      <!-- <el-dialog title="提示" :visible.sync="dialogVisible" width="70%">
				<p style="color: red;">注意：所有字段均為必填，表格請不要加樣式，表格應新增表頭，所有列應為文本格式，文件格式為Excel</p>
				例：
				<img width="90%" src="../assets/assessmentSet.png" />
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-upload
						class="upload-demo"
						action=""
						:on-change="change"
						:show-file-list="false"
						:auto-upload="false"
						accept=".xls,.xlsx"
						:limit="1"
						:file-list="fileList"
					>
						<el-button type="primary">點擊上傳</el-button>
					</el-upload>
				</span>
			</el-dialog> -->
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
export default {
  data() {
    return {
      pageLoading: false,

      testPage: {
        ueviomsName: "",
        name: "",
      },
      tableData: [],
      topic: {
        optionA: "",
        optionB: "",
        optionC: "",
        optionD: "",
        content: "",
        type: 0,
      },
      dialogFormVisible: false,
      dialogFormQuestionnaire: false,
      courseType: "",
      fileList: [],
      questionnaireName: [],
      dialogVisible: false,
      id: "",
    };
  },
  mounted() {
    $("#pageHead").text("課程反饋設置");
  },
  methods: {
    learning() {
      this.$router.push("/home/learningDetails");
    },
    viewTest(id) {
      console.log(id);
      this.$router.push("/home/testPaper");
    },
    viewAssessment(id) {
      console.log(id);
      this.$router.push("/home/assessment");
    },
    del(index) {
      this.$confirm("確認刪除？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "確定",
        type: "warning",
      })
        .then(() => {
          this.tableData.splice(index, 1);
          this.$message({
            type: "success",
            message: "刪除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消刪除",
          });
        });
    },
    addTopic() {
      // 新增題目
      var topic = this.topic;
      for (let item in topic) {
        if (topic[item] === "") {
          this.$message({
            type: "warning",
            message: "請將題目填寫完整",
          });
          return;
        }
      }
      this.tableData.push(JSON.parse(JSON.stringify(topic)));
      for (let item in topic) {
        topic[item] = "";
      }
      topic.type = 0;
      this.dialogFormVisible = false;
    },
    delQuestionnaire(index) {
      this.$confirm("確認刪除？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "確定",
        type: "warning",
      })
        .then(() => {
          this.questionnaireName.splice(index, 1);
          this.$message({
            type: "success",
            message: "刪除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消刪除",
          });
        });
    },
    addQuestionnaire() {
      if (this.testPage.name == "") {
        this.$message({
          type: "warning",
          message: "請新增問答題題目",
        });
        return;
      }
      this.questionnaireName.push(this.testPage.name);
      // this.tableData.push({ type: '1', content: testPage.name, optionA: '', optionB: '', optionC: '', optionD: '' });
      this.testPage.name = "";
      this.dialogFormQuestionnaire = false;
    },
    change(file) {
      let that = this;
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          }); // 读取数据
          const wsname = workbook.SheetNames[0]; // 取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // 生成json表格内容
          // const ws1 = XLSX.utils.sheet_to_slk(workbook.Sheets[wsname]) // 输出表格对应位置是什么值
          // const ws2 = XLSX.utils.sheet_to_html(workbook.Sheets[wsname]) // 生成HTML输出
          // const ws3 = XLSX.utils.sheet_to_csv(workbook.Sheets[wsname]) // 生成分隔符分隔值输出
          // const ws4 = XLSX.utils.sheet_to_formulae(workbook.Sheets[wsname]) // 生成公式列表（具有值回退）
          // const ws5 = XLSX.utils.sheet_to_txt(workbook.Sheets[wsname]) // 生成UTF16格式的文本
          // that.outputs = []; // 清空接收数据
          let table = [];
          for (let i = 0; i < ws.length; i++) {
            let sheetData = ws[i]; // 对数据自行操作
            // if (sheetData.length != 4) {
            // 	this.$message({
            // 		type: 'warning',
            // 		message: '您的文檔格式不正確'
            // 	});
            // 	return;
            // }
            for (let item in sheetData) {
              if (
                item != "題目" &&
                item != "選項A" &&
                item != "選項B" &&
                item != "選項C" &&
                item != "選項D"
              ) {
                console.log(item);
                this.$message({
                  type: "warning",
                  message: "您的文檔格式不正確",
                });
                return;
              }
              if (sheetData[item] == "") {
                this.$message({
                  type: "warning",
                  message: "請將題目填寫完整",
                });
                return;
              }
            }
            table.push(sheetData);
          }
          table.forEach((item) => {
            that.tableData.push({
              type: "0",
              content: item["題目"],
              optionA: item["選項A"],
              optionB: item["選項B"],
              optionC: item["選項C"],
              optionD: item["選項D"],
            });
          });
          that.dialogVisible = false;
        } catch (e) {
          console.log(e);
          return false;
        }
      };
      that.fileList = [];
      fileReader.readAsBinaryString(file.raw);
      // ————————————————
      // 版权声明：本文为CSDN博主「jarisMA」的原创文章，遵循 CC 4.0 BY-SA 版权协议，转载请附上原文出处链接及本声明。
      // 原文链接：https://blog.csdn.net/jarisMA/article/details/100106526
    },
    addAsses() {
      // 提交反饋
      var testPage = JSON.parse(JSON.stringify(this.testPage));
      var tableData = JSON.parse(JSON.stringify(this.tableData));
      if (testPage.ueviomsName == "") {
        this.$message({
          type: "warning",
          message: "請將填寫反饋表名稱",
        });
        return;
      }
      if (tableData.length == 0) {
        this.$message({
          type: "warning",
          message: "請新增題目",
        });
        return;
      }
      // if (testPage.name == '') {
      //   this.$message({
      //     type: 'warning',
      //     message: '請新增問答題題目'
      //   });
      //   return;
      // }
      if (this.questionnaireName.length <= 0) {
        this.$message({
          type: "warning",
          message: "請新增問答題題目",
        });
        return;
      }
      for (let i = 0; i < this.questionnaireName.length; i++) {
        tableData.push({
          type: "1",
          content: this.questionnaireName[i],
          optionA: "",
          optionB: "",
          optionC: "",
          optionD: "",
        });
      }
      var table = JSON.stringify(tableData);

      var that = this;
      var url = "";
      if (this.id) {
        // 修改
        let type = 0;
        if (this.courseType == "offline") {
          type = 2;
        } else if (this.courseType == "online") {
          type = 1;
        } else if (this.courseType == "live") {
          type = 3;
        }
        testPage["manOnlineZevalua"] = table;
        testPage["type"] = type;
        testPage["id"] = this.id;
        this.pageLoading = true
        this.axios.post("/manage/updateManUevioms", this.qs.stringify(testPage))
        .then(res => {
          if (res) {
            that.$message({
              message: "修改成功",
              type: "success",
            });
            sessionStorage.assessmentMsg = JSON.stringify({
              // id: res.message,
              id: this.id,
              name: testPage.ueviomsName,
            });
            setTimeout(function () {
              that.$emit("back");
            }, 1000);
          } else {
            this.pageLoading = false
          }
        }).catch(() => {
          this.pageLoading = false
        })
      } else {
        if (this.courseType == "offline") {
          url = "/manage/addManOfflineUevioms";
          testPage["manOfflineZevalua"] = table;
        } else if (this.courseType == "online") {
          url = "/manage/addManOnlineUevioms";
          testPage["manOnlineZevalua"] = table;
        } else if (this.courseType == "live") {
          url = "/manage/addManLiveUevioms";
          testPage["manLiveZevalua"] = table;
        }
        console.log(testPage);
        this.pageLoading = true
        this.axios.post(url, this.qs.stringify(testPage)).then(res => {
          if (res) {
            that.$message({
              message: "新增成功",
              type: "success",
            });
            sessionStorage.assessmentMsg = JSON.stringify({
              id: res.message,
              name: testPage.ueviomsName,
            });
            setTimeout(function () {
              that.$emit("back");
            }, 1000);
          } else {
            this.pageLoading = false
          }
        }).catch(() => {
          this.pageLoading = false
        })
      }
    },
    back() {
      if (
        this.testPage.ueviomsName ||
        this.tableData.length > 0 ||
        this.testPage.name
      ) {
        this.$confirm("資料尚未儲存，確定離開?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$emit("back");
          })
          .catch(() => {});
      } else {
        this.$emit("back");
      }
    },
    getVersion() {
      var x2js = new x2js();
      // var obj = x2js.xml_str2json(res.data).note;
      var jsonObj = x2js.xml2js();
      console.log(jsonObj.note);
      // _self.tableData = jsonObj.note.specialityList.item;
      // _self.changeData = jsonObj.note.changeList.item;
      // _self.finishData = jsonObj.note.finishedPunchList.item;
      // _self.knownData = jsonObj.note.questionList.item;
      // _self.versionDes = jsonObj.note.name;
      // _self.versionDate = jsonObj.note.date;
    }, 
    importTemplate() {
      this.pageLoading = true
      this.axios.get("/manage/getManModelZevalua").then((res) => {
        if (res) {
          let arr = [],
            arr2 = [],
            result = res.result;

          result.forEach((item) => {
            if (item.contentType == 0) {
              arr.push({
                optionA: item.optionA || "",
                optionB: item.optionB || "",
                optionC: item.optionC || "",
                optionD: item.optionD || "",
                content: item.content,
                type: item.contentType + "",
              });
            } else if (item.contentType == 1) {
              arr2.push(item.content);
            }
          });
          // if (question) {
          //   this.testPage.name = question.content;
          // }

          this.tableData = arr;
          this.questionnaireName = arr2;
          if (result.length == 0) {
            // this.$message({
            // 	message: '請先新增模板',
            // 	type: 'warning'
            // });
            this.$confirm(
              "當前沒有模板沒有數據，是否離開當前頁面去新增",
              "提示",
              {
                confirmButtonText: "確認",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                this.$router.push("assessmentTemplate");
              })
              .catch(() => {});
          }

          this.pageLoading = false
        }
      });
    },
  },
  created() {
    this.courseType = sessionStorage.getItem("courseType");
    let assessmentSet = sessionStorage.getItem("assessmentSet");
    if (assessmentSet) {
      let msg = JSON.parse(assessmentSet);
      this.testPage.ueviomsName = msg.name;
      this.id = msg.id;
      let type = 0;
      if (this.courseType == "offline") {
        type = 2;
      } else if (this.courseType == "online") {
        type = 1;
      } else if (this.courseType == "live") {
        type = 3;
      }
      this.pageLoading = true
      this.axios({
        url: "/manage/getOnlineEchoEvaluation",
        params: {
          id: this.id,
          type,
        },
      }).then((res) => {
        if (res) {
          let tableData = [];
          res.result.list.forEach((item) => {
            if (item.type == 0) {
              tableData.push(item);
            } else {
              // this.testPage.name = item.content;
              this.questionnaireName.push(item.content);
            }
          });
          this.tableData = tableData;
        }
        this.pageLoading = false
      });
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem("assessmentSet");
  },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: space-around;
  width: 400px;
  margin: auto;
}
ol button {
  margin-left: 20px;
}
ol h4 {
  margin: 10px 0;
}
.code img {
  width: 100px;
}
.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}
.el-form-radio {
  padding-left: 26px;
  margin: 20px 0;
}
.el-form-radio label {
  margin-right: 20px;
  width: 34px;
}
.el-form-radio .el-input {
  width: 70%;
}
.upload-demo {
  margin-left: 10px;
}
.item {
  margin-top: 10px;
  margin-right: 20px;
}
</style>
